module.exports = __webpack_public_path__ + "img/logo-xunta-on.c52a7399.png";